/**
 * CitationList Component
 *
 * Renders a horizontal list of citations matching the Figma design
 * Shows citations at the bottom of assistant messages
 */

import React from 'react';
import { Group, Badge, Anchor } from '@mantine/core';
import classes from './CitationList.module.css';
import type { Citation } from '../types';

interface CitationListProps {
  citations: Citation[];
  onCitationClick?: (citation: Citation) => void;
  className?: string;
}

export const CitationList: React.FC<CitationListProps> = ({
  citations,
  onCitationClick,
  className
}) => {
  if (citations.length === 0) return null;

  return (
    <Group gap={6} className={`${classes.container} ${className || ''}`}>
      {citations.map((citation) => (
        <Anchor
          key={citation.id}
          href={citation.url || '#'}
          target={citation.url ? '_blank' : undefined}
          rel={citation.url ? 'noopener noreferrer' : undefined}
          className={classes.citationLink}
          onClick={(e) => {
            // Always prevent native anchor navigation — the parent
            // handler (AssistantMessage) owns URL opening via safelyOpenUrl
            // to avoid multiple tabs being opened simultaneously.
            e.preventDefault();
            onCitationClick?.(citation);
          }}
          underline="never"
          style={{ cursor: 'pointer' }}
        >
          <Badge
            variant="light"
            color="blue"
            size="sm"
            className={classes.citationBadge}
          >
            {citation.index}. {citation.text}
          </Badge>
        </Anchor>
      ))}
    </Group>
  );
};
